import { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import SearchIcon from "@mui/icons-material/Search";
import PatientController from "../../controller/PatientController";
import DepartmentController from "../../controller/DepartmentController";
import SubDepartmentController from "../../controller/SubDepartmentController";
import ServiceController from "../../controller/ServiceController.jsx";
import DoctorController from "../../controller/DoctorController";
import MedicalFeeReceiptController from "../../controller/MedicalFeeReceiptDetailsController";
import MedicalFeeDetailController from "../../controller/MedicalFeeDetailController";
import AssociateController from "../../controller/DoctorAssociateController";
import MasterController from "../../controller/MastersController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import dayjs from "dayjs";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid,
    useTheme,
    Box,
    Stack,
    Checkbox,
    TextField,
    FormGroup,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";

const objectIdRegex = /^[0-9a-fA-F]{24}$/;

const INITIAL_FORM_STATE = {
    patientFamilyId: "",
    patientMobileType: "",
    patientFirstName: "",
    patientMiddleName: "",
    patientLastName: "",
    patientEmailId: "",
    patientMobileNumber: "",
    patientAddress1: "",
    patientAddress2: "",
    patientCity: "",
    patientState: "",
    patientPincode: "",
};
const FORM_VALIDATION = Yup.object().shape({
    patientFamilyId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, "Invalid  DoctorId format") // ✅ Only for ObjectId
        .optional(),
    patientFirstName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Patient First Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Patient First Name should not exceed 100 characters")
        .required("Patient First Name is required"),
    patientMiddleName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Patient Middle Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Patient Middle Name should not exceed 100 characters")
        .required("Patient Middle Name is required"),
    patientLastName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Patient Last Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Patient Last Name should not exceed 100 characters")
        .required("Patient Last Name is required"),

    patientEmailId: Yup.string()
        .email("Patient Email is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .required("Patient Email is required"),

    patientMobileNumber: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Patient Mobile is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .required("Patient Mobile is required"),

    patientMobileType: Yup.string()
        .required("Please select Self or Family"),

    patientAddress1: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Patient Address1  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(200, "Patient Address1 should not exceed 50 characters")
        .optional(),
    patientAddress2: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Patient Address2  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(200, "Patient Address2 should not exceed 50 characters")
        .optional(),
    patientCity: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Patient City  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Patient City should not exceed 50 characters")
        .optional(),
    patientState: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Patient State  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Patient State should not exceed 50 characters")
        .optional(),
    patientPincode: Yup.string()
        .matches(/^\d{6}$/, "Patient PinCode must be exactly 6 digits")
        .required("PinCode  is required"),
});

const FeeDetails_INITIAL_FORM_STATE = {
    // feeReceiptId: "",
    patientId: "",
    departmentId: [],
    subDepartmentId: [],
    serviceId: [],
    doctorId: [],
    associateId: "",
    visitDate: "",
    nextVisitDate: "",
    feeStatus: "",
    feeAmount: "",
}
const FeeDetails_FORM_VALIDATION = Yup.object().shape({

    // feeReceiptId: Yup.string()
    //     .trim("No white space allowed")
    //     .strict(true)
    //     .required("Fee Receipt ID is required"),

    patientId: Yup.string()
        .required("Patient is required"),

    departmentId: Yup.string()
        .required("Department is required"),

    subDepartmentId: Yup.string()
        .required("Sub Department is required"),

    serviceId: Yup.string()
        .required("Service is required"),

    doctorId: Yup.string()
        .required("Doctor is required"),

    associateId: Yup.string()
        .required("Associate is required"),

    visitDate: Yup.date()
        .typeError("Visit Date is not valid")
        .required("Visit Date is required"),

    nextVisitDate: Yup.date()
        .typeError("Next Visit Date is not valid")
        .min(
            Yup.ref("visitDate"),
            "Next Visit Date cannot be before Visit Date"
        )
        .required("Next Visit Date is required"),

    feeStatus: Yup.string()
        .oneOf(["Paid", "Pending", "Partially Paid"], "Invalid Fee Status")
        .required("Fee Status is required"),

    feeAmount: Yup.number()
        .typeError("Fee Amount must be a number")
        .min(10, "Fee Amount must be at least 2 digits")
        .max(9999999999, "Fee Amount cannot exceed 10 digits")
        .required("Fee Amount is required"),
});

const FeeReceiptDetails_INITIAL_FORM_STATE = {
    feeDetailsId: "",
    patientId: "",
    paymentAmount: "",
    modeOfPayment: "",
    dateOfReceipt: "",
    transactionReferenceNumber: "",
    paymentReferenceNumber: "",
    receiptNo: "",
    receiptDate: "",
};
const FeeReceiptDetails_FORM_VALIDATION = Yup.object().shape({
    feeDetailsId: Yup.string()
        .matches(objectIdRegex, "Invalid Fee Details ID")
        .required("Fee Details ID is required"),

    patientId: Yup.string()
        .matches(objectIdRegex, "Invalid Patient ID")
        .required("Patient ID is required"),

    paymentAmount: Yup.number()
        .typeError("Payment amount must be a number")
        .positive("Payment amount must be greater than 0")
        .min(10, "Payment Amount must be at least 2 digits")
        .max(9999999999, "Payment amount cannot exceed 10 digits")
        .required("Payment amount is required"),

    modeOfPayment: Yup.string()
        .oneOf(["Cash", "Credit Card", "Debit Card", "UPI", "NetBanking", "None"], "Invalid payment mode")
        .required("Mode of Payment is required"),

    dateOfReceipt: Yup.string()
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
            "Date of Receipt must be in DD/MM/YYYY format"
        )
        .required("Date of Receipt is required"),

    transactionReferenceNumber: Yup.string()
        .trim()
        .required("Transaction Reference Number is required"),

    paymentReferenceNumber: Yup.string()
        .trim()
        .required("Payment Reference Number is required"),

    receiptNo: Yup.string()
        .trim()
        .required("Receipt No is required"),

    receiptDate: Yup.string()
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
            "Receipt Date must be in DD/MM/YYYY format"
        )
        .required("Receipt Date is required"),
});

let requestType = "";
const Patient = () => {
    const patientController = new PatientController();
    const medicalFeeDetailController = new MedicalFeeDetailController();
    const departmentController = new DepartmentController();
    const subDepartmentController = new SubDepartmentController();
    const serviceController = new ServiceController();
    const doctorController = new DoctorController();
    const associateController = new AssociateController();
    const setFieldFunction = { setFieldValue: () => { } }
    const medicalFeeReceiptController = new MedicalFeeReceiptController();
    const masterController = new MasterController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [patientFamilyOptions, setPatientFamilyOptions] = useState()
    const [patientData, setPatientData] = useState([]);
    const [feeDetailData, setFeeDetailData] = useState([]);
    const [feeReceiptData, setFeeReceiptData] = useState([]);
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [updatedFeeDetailValues, setUpdatedFeeDetailValues] = useState(FeeDetails_INITIAL_FORM_STATE);
    const [updatedFeeReceiptDetailValues, setUpdatedFeeReceiptDetailValues] = useState(FeeReceiptDetails_INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [isDropdown, setIsDropdown] = useState(false);
    const [showMobileOptions, setShowMobileOptions] = useState(false);
    const [familyNameDD, setFamilyNameDD] = useState([]);
    const [popup, setPopUp] = useState(false);
    const [feeReceiptDetailPopup, setFeeReceiptDetailPopup] = useState(false);
    const [feeDetailPopup, setFeeDetailPopup] = useState(false);
    const [popup3, setPopUp3] = useState(false);
    const [allPatientData, setAllPatientData] = useState([]);
    const [allFeeDetailData, setAllFeeDetailData] = useState([]);
    const [allFeeReceiptData, setAllFeeReceiptData] = useState([]);

    // Fee Details
    // const [departmentId, setDepartmentId] = useState('');
    // const { values, setFieldValue } = useFormikContext(); // ✅ get both from context

    const [departmentOptions, setDepartmentOptions] = useState();
    const [subDepartmentOptions, setSubDepartmentOptions] = useState([]);
    const [serviceOptions, setServiceOptions] = useState([])
    const [doctorOptions, setDoctorOptions] = useState([])
    const [associateOptions, setAssociateOptions] = useState([])
    const [patientOptions, setPatientOptions] = useState([])
    const [departmentSearch, setDepartmentSearch] = useState("");
    const [subDeptSearch, setSubDeptSearch] = useState("");
    const [subDepartmentsMap, setSubDepartmentsMap] = useState({}); // deptId -> subDepartments[]
    const [serviceMap, setServiceMap] = useState({}); // subDeptId -> services[]
    const [doctorMap, setDoctorMap] = useState({}); // serviceId -> doctors[]
    const [serviceSearch, setServiceSearch] = useState("");
    const [doctorSearch, setDoctorSearch] = useState("");


    // Fee Receipt
    const [feeReceiptOption, setFeeReceiptOption] = useState([])

    // patient page 
    const [patientPage, setPatientPage] = useState(true)
    const [feeDetailPage, setFeeDetailPage] = useState(false)
    const [feeReceiptDetailPage, setFeeReceiptDetailPage] = useState(false)

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllPatient();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // useEffect(() => {
    //     console.log('departmentId :', departmentId);

    // }, [departmentId]);

    const handleFamilyName = async (value) => {
        setIsDropdown(false);
        try {
            const resultObj = await patientController.GetPatientFamily(value, token);
            if (resultObj.status === 200) {
                const familyName = resultObj?.data?.body || [];
                const fetchedFamilyNameDD = familyName
                    .filter((item) => item?.familyName && item?.patientFamilyId)
                    .map((item) => ({
                        familyName: item.familyName,
                        patientFamilyId: item.patientFamilyId,
                    }));

                setFamilyNameDD(fetchedFamilyNameDD);
                setIsDropdown(true);
                return fetchedFamilyNameDD;
            } else {
                showAlert("error", resultObj?.response?.data?.message);
                return []; // Returning an empty array on error
            }
        } catch (error) {
            const logData = {
                message: error.message,
                stack: error.stack,
            };
            const logError = {
                logData,
                module: "memberShip handleFamilyName method",
            };
            exceptionHandlerController.HandleException(logError);
            return []; // Returning an empty array on exception
        }
    };
    const getPinCodeData = async (pin, setFieldValue) => {
        let caughtError;
        try {
            const pinData = { pincode: Number(pin) };
            const pinResponse = await masterController.GetLocation(pinData)
            if (pinResponse.status === 200) {
                const pinRes = pinResponse?.data?.body?.pincode;
                setFieldValue("patientCity", pinRes?.city || "");
                setFieldValue("patientPincode", String(pinRes.pincode) || "");
                setFieldValue("patientState", pinRes?.state || "");
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getPinCodeData",
            };
            exceptionHandlerController.HandleException(logError);
        }
    }

    const getAllPatient = async () => {
        let caughtError;
        try {
            const response = await patientController.GetAllPatient(token);
            if (response.status === 200) {
                const data = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setPatientData(data);
                // only id + name for options
                const options = response?.data?.body?.map((item) => ({
                    patientId: item._id,
                    patientName: `${item.patientFirstName || ""} ${item.patientMiddleName || ""}`.trim(),
                }));
                setPatientOptions(options);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllPatient",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    // Start FeeDetail
    const getAllFeeDetail = async () => {
        //debugger
        let caughtError;
        try {
            const response = await medicalFeeDetailController.GetAllFeeDetail(token);
            if (response.status === 200) {
                const data = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setFeeDetailData(data);
                // setFeeReceiptOption(data);
                const options = response?.data?.body?.map((item) => ({
                    id: item._id,
                    patientId: item.patientId,
                    patientName: item.patientName,
                }));
                setFeeReceiptOption(options);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllFeeDetail in patientPage",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDepartment = async () => {
        let caughtError;
        try {
            const response = await departmentController.GetDepartmentOptions(token);
            if (response.status === 200) {
                const departmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    departmentName: item.departmentName,
                    departmentId: item._id,
                }));
                setDepartmentOptions(departmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDepartment in Patient page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getSubDepartment = async (departmentId) => {
        let caughtError;
        if (subDepartmentsMap[departmentId]) {
            return subDepartmentsMap[departmentId]; // ✅ already cached
        }

        try {
            const response = await subDepartmentController.GetSubDepartmentById(departmentId, token);
            if (response.status === 200) {
                const subDepartmentData = response?.data?.body?.map((item) => ({
                    subDepartmentName: item.subDepartmentName,
                    subDepartmentId: item._id,
                    departmentId
                }));

                setSubDepartmentsMap((prev) => ({
                    ...prev,
                    [departmentId]: subDepartmentData
                }));

                return subDepartmentData;
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getSubDepartment in Service Page",
            };
            exceptionHandlerController.HandleException(logError);
            return [];
        }
    };
    const getServicesBySubDepartmentId = async (subDepartmentId) => {
        let caughtError;
        if (serviceMap[subDepartmentId]) {
            return serviceMap[subDepartmentId]; // ✅ cached
        }

        try {
            const response = await serviceController.GetServiceBySubDepartmentId(subDepartmentId, token);
            if (response.status === 200) {
                const services = response?.data?.body?.map((item) => ({
                    serviceId: item._id,
                    serviceName: item.serviceName,
                    subDepartmentId,
                }));

                setServiceMap((prev) => ({ ...prev, [subDepartmentId]: services }));

                return services;
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "GetServiceBySubDepartmentId in Patient Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getDoctorsByDepartmentId = async (departmentId) => {
        let caughtError;
        if (doctorMap[departmentId]) return doctorMap[departmentId]; // ✅ cached

        try {
            const response = await doctorController.GetDoctorsByDepartmentId(departmentId, token);
            if (response.status === 200) {
                const doctors = response?.data?.body?.map((item) => ({
                    doctorId: item._id,
                    doctorName: item.doctorName,
                    departmentId,
                }));

                setDoctorMap((prev) => ({ ...prev, [departmentId]: doctors }));
                return doctors;
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getDoctorsByDepartmentId in Patient Page",
            };
            exceptionHandlerController.HandleException(logError);
            return [];
        }
    };


    const getAllAssociate = async () => {
        let caughtError;
        try {
            const response = await associateController.GetAllAssociate(token);
            if (response.status === 200) {
                const associateData = response?.data?.body?.map((item) => ({
                    // ...item,
                    associateName: item.associateName,
                    associateId: item._id,
                }));
                setAssociateOptions(associateData);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllAssociate in Patient Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const handleVisitDateChange = (setFieldTouched, setFieldValue, e) => {
        const formatted = moment(new Date(e)).format("DD/MM/YYYY");
        setFieldTouched("visitDate", true);
        setFieldValue("visitDate", formatted);
    };
    const handleNextVisitDateChange = (setFieldTouched, setFieldValue, e) => {
        const formatted = moment(new Date(e)).format("DD/MM/YYYY");
        setFieldTouched("nextVisitDate", true);
        setFieldValue("nextVisitDate", formatted);
    };
    const feeStatusOptions = [
        { value: "Paid", label: "Paid" },
        { value: "Pending", label: "Pending" },
        { value: "Partially Paid", label: "Partially Paid" },
    ];



    // End FeeDetail

    // Start Fee Receipt
    const getAllFeeReceipt = async () => {
        let caughtError;
        try {
            const response = await medicalFeeReceiptController.GetAllFeeReceipt(token);
            if (response.status === 200) {
                const data = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setFeeReceiptData(data ?? '');

                // const options = response?.data?.body?.map((item) => ({
                //     id: item._id,
                //     patientId: item.patientId,
                //     patientName: item.patientName,
                // }));
                // setFeeReceiptOption(options);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllFeeReceipt in patientPage",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const handleDateOfReceiptChange = (setFieldTouched, setFieldValue, e) => {
        const formatted = moment(new Date(e)).format("DD/MM/YYYY");
        setFieldTouched("dateOfReceipt", true);
        setFieldValue("dateOfReceipt", formatted);
    };
    const handleReceiptDateChange = (setFieldTouched, setFieldValue, e) => {
        const formatted = moment(new Date(e)).format("DD/MM/YYYY");
        setFieldTouched("receiptDate", true);
        setFieldValue("receiptDate", formatted);
    };

    const paymentModeOptions = [
        { value: "Cash", label: "Cash" },
        { value: "Credit Card", label: "Credit Card" },
        { value: "Debit Card", label: "Debit Card" },
        { value: "UPI", label: "UPI" },
        { value: "NetBanking", label: "Net Banking" },
        { value: "None", label: "None" },
    ];


    // End Fee Receipt

    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Patient First Name", field: "patientFirstName", width: 210 },
        { headerName: "Patient Middle Name", field: "patientMiddleName", width: 210 },
        // { headerName: "Patient Last Name", field: "patientLastName", width: 210 },
        { headerName: "Patient Email", field: "patientEmailId", width: 210 },
        { headerName: "Patient Mobile", field: "patientMobileNumber", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            setIsDropdown(true);
                            setFamilyNameDD([{
                                familyName: currentRow.familyName,
                                patientFamilyId: currentRow.patientFamilyId
                            }]);
                            if (currentRow.patientMobileNumber.length === 10) {
                                setShowMobileOptions(true);
                            }
                            handleData();
                        } else {
                            patientController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllPatient()
                                        showAlert("success", "Deleted successfully");
                                        setAllPatientData((i) => {
                                            return allPatientData.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Patient onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];
    const getFeeColumns = (setFieldValue, setUpdatedFeeDetailValues,) => [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Patient Name", field: "patientName", width: 180 },
        { headerName: "Mobile Number", field: "patientMobileNumber", width: 180 },
        { headerName: "Visit Date", field: "visitDate", width: 180 },
        { headerName: "Paid Amount", field: "paidFeeAmount", width: 100 },
        { headerName: "Next Visit Date", field: "nextVisitDate", width: 180 },
        { headerName: "Fee Amount", field: "feeAmount", width: 120 },
        {
            field: "action",
            headerName: "Action",
            width: 120,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            debugger
                            setUpdatedFeeDetailValues(() => currentRow);

                            setDepartmentOptions(currentRow?.departments)
                            console.log('currentRow?.departments :', currentRow?.departments);
                            setSubDepartmentOptions(currentRow?.subDepartments)
                            setServiceOptions(currentRow?.services)
                            setDoctorOptions(currentRow?.doctors)
                            debugger
                            // setFieldValue(
                            //     "departmentId",
                            //     currentRow.departments?.map((d) => String(d.departmentId)) || []
                            //     // true
                            // );
                            // setFieldValue(
                            //     "subDepartmentId",
                            //     currentRow.subDepartments?.map((s) => s.subDepartmentId) || []
                            // );
                            // setFieldFunction.setFieldValue(
                            //     "serviceId",
                            //     currentRow.services?.map((s) => s.serviceId) || []
                            // );
                            // setFieldFunction.setFieldValue(
                            //     "doctorId",
                            //     currentRow.doctors?.map((d) => d.doctorId) || []
                            // );
                            showAlert("success", "can't update fee details");
                            getAllDepartment();
                            // // 2️⃣ store row data to trigger useEffect
                            // // updatedFeeDetailValues(currentRowData);

                            // // setAssociateOptions([{
                            // //     associateName: currentRow.associateName,
                            // //     associateId: currentRow.associateId
                            // // }])
                            handleFeeDetailData();
                        } else {
                            medicalFeeDetailController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllFeeDetail()
                                        showAlert("success", "Deleted successfully");
                                        setAllFeeDetailData((i) => {
                                            return allFeeDetailData.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Patient feeDetailColumns onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];
    const feeReceiptColumns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Receipt No", field: "receiptNo", width: 120 },
        { headerName: "Patient Name", field: "patientName", width: 210 },
        { headerName: "Mobile", field: "patientMobileNumber", width: 120 },
        { headerName: "Fee Amount", field: "feeAmount", width: 150 },
        { headerName: "Payment Amount", field: "paymentAmount", width: 150 },
        {
            field: "action",
            headerName: "Action",
            width: 120,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedFeeReceiptDetailValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedFeeReceiptDetailValues(() => currentRowData);
                            setFeeReceiptOption([{
                                patientName: currentRow.patientName,
                                patientId: currentRow.patientId,
                                id: currentRow.feeDetailsId
                            }])
                            getAllFeeDetail()
                            handleFeeReceiptDetailData()
                        } else {
                            medicalFeeReceiptController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllFeeReceipt()
                                        showAlert("success", "Deleted successfully");
                                        setAllFeeReceiptData((i) => {
                                            return allFeeReceiptData.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Patient feeReceiptColumn onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const handleAddFamilyName = (setFieldValue) => {
        setIsDropdown(false);
        resetFamilyNameFields(setFieldValue);
        handleData3();
    };
    const resetFamilyNameFields = (setFieldValue) => {
        setFieldValue("familyMobileNumber", "");
        setFieldValue("selectedDDfamilyName", null);
    };
    const AddPatient = async () => {
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        setIsDropdown(false);
        handleData();
    };

    const AddFeeDetail = async () => {
        // //debugger
        requestType = "Add";
        setUpdatedFeeDetailValues(() => FeeDetails_INITIAL_FORM_STATE);

        setDepartmentOptions()
        setSubDepartmentOptions()
        setServiceOptions()
        setDoctorOptions()
        getAllDepartment();
        getAllAssociate();
        handleFeeDetailData();
    };
    const AddFeeReceiptDetail = async () => {
        requestType = "Add";
        getAllFeeDetail();
        setUpdatedFeeReceiptDetailValues(() => FeeReceiptDetails_INITIAL_FORM_STATE);
        handleFeeReceiptDetailData();
    };
    const PatientPage = () => {
        setPatientPage(true)
        setFeeDetailPage(false)
        setFeeReceiptDetailPage(false)
    }
    const FeeDetailPage = () => {
        setPatientPage(false)
        setFeeReceiptDetailPage(false)
        setFeeDetailPage(true)
        getAllFeeDetail()
    }
    const FeeReceiptDetailPage = () => {
        setPatientPage(false)
        setFeeDetailPage(false)
        setFeeReceiptDetailPage(true)
        getAllFeeReceipt();
    }

    const submitValues = (submitValueData) => {
        let submitData = {}
        submitData.tenantId = tenantId;
        // Map form fields
        if (submitValueData?.patientFamilyId.length > 0) {
            submitData.patientFamilyId = submitValueData?.patientFamilyId;
        }
        submitData.patientFirstName = submitValueData?.patientFirstName?.trim() ?? '';
        submitData.patientMiddleName = submitValueData?.patientMiddleName?.trim() ?? '';
        submitData.patientLastName = submitValueData?.patientLastName?.trim() ?? '';
        submitData.patientEmailId = submitValueData?.patientEmailId?.trim() ?? '';
        submitData.patientMobileNumber = submitValueData?.patientMobileNumber?.trim() ?? '';
        submitData.patientMobileType = submitValueData?.patientMobileType?.trim() ?? '';
        submitData.patientAddress1 = submitValueData?.patientAddress1?.trim() ?? '';
        submitData.patientAddress2 = submitValueData?.patientAddress2?.trim() ?? '';
        submitData.patientCity = submitValueData?.patientCity?.trim() ?? '';
        submitData.patientState = submitValueData?.patientState?.trim() ?? '';
        submitData.patientPincode = submitValueData?.patientPincode?.trim() ?? '';

        //add for image
        if (requestType === "Edit") {
            // //debugger
            submitData.id = submitValueData?.id;
            const id = submitValueData?.id;
            // assuming ID comes from backend
            patientController
                .Update(id, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllPatient()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.response?.data?.status === 400)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            patientController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllPatient()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 400) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };

    const validateHierarchyWithNames = (
        values = {},
        departmentOptions = [],
        subDepartmentOptions = [],
        serviceOptions = [],
        doctorOptions = []
    ) => {
        let {
            departmentId = [],
            subDepartmentId = [],
            serviceId = [],
            doctorId = [],
        } = values;

        // 🔑 normalize everything into arrays
        departmentId = Array.isArray(departmentId) ? departmentId : [departmentId].filter(Boolean);
        subDepartmentId = Array.isArray(subDepartmentId) ? subDepartmentId : [subDepartmentId].filter(Boolean);
        serviceId = Array.isArray(serviceId) ? serviceId : [serviceId].filter(Boolean);
        doctorId = Array.isArray(doctorId) ? doctorId : [doctorId].filter(Boolean);

        // 1. Check each department
        for (const depId of departmentId) {
            const depName =
                departmentOptions.find((dep) => dep.departmentId === depId)?.departmentName ||
                depId;

            const subForDep = subDepartmentOptions
                .filter((sd) => sd.departmentId === depId)
                .map((sd) => sd.subDepartmentId);

            const svcForDep = serviceOptions
                .filter((svc) => subForDep.includes(svc.subDepartmentId))
                .map((svc) => svc.serviceId);

            const docForDep = doctorOptions
                .filter((doc) => doc.departmentId === depId)
                .map((doc) => doc.doctorId);

            if (
                !subDepartmentId.some((id) => subForDep.includes(id)) &&
                !serviceId.some((id) => svcForDep.includes(id)) &&
                !doctorId.some((id) => docForDep.includes(id))
            ) {
                return {
                    valid: false,
                    message: `Please select at least one SubDepartment, Service, or Doctor for Department: ${depName}`,
                };
            }
        }

        // 2. Check each subDepartment (🔑 Doctor validation here)
        for (const subId of subDepartmentId) {
            const subName =
                subDepartmentOptions.find((sd) => sd.subDepartmentId === subId)?.subDepartmentName ||
                subId;

            const svcForSub = serviceOptions
                .filter((svc) => svc.subDepartmentId === subId)
                .map((svc) => svc.serviceId);

            const docForSub = doctorOptions
                .filter((doc) => doc.subDepartmentId === subId)
                .map((doc) => doc.doctorId);

            if (
                !serviceId.some((id) => svcForSub.includes(id)) &&
                !doctorId.some((id) => docForSub.includes(id))
            ) {
                return {
                    valid: false,
                    message: `Please select at least one Service or Doctor for SubDepartment: ${subName}`,
                };
            }
        }

        // 3. ✅ Only check that services exist (no doctor check here)
        for (const svcId of serviceId) {
            const svcName =
                serviceOptions.find((svc) => svc.serviceId === svcId)?.serviceName ||
                svcId;

            // 🔥 removed doctor validation here
            if (!svcName) {
                return {
                    valid: false,
                    message: `Invalid Service selected: ${svcId}`,
                };
            }
        }

        return { valid: true };
    };

    const submitFeeDetailValues = (submitValueData) => {
        debugger
        const validation = validateHierarchyWithNames(
            // submitValueData.values,
            submitValueData,
            departmentOptions,
            subDepartmentOptions,
            serviceOptions,
            doctorOptions
        );
        ;

        if (!validation.valid) {
            showAlert("error", validation.message);
            // alert(validation.message);
            return;
        }

        let submitData = {}
        submitData.tenantId = tenantId;
        // submitData.FeeReceiptID = submitValueData.FeeReceiptID.trim() ?? '';
        submitData.patientId = submitValueData.patientId.trim() ?? '';
        submitData.departmentId = submitValueData.departmentId;
        submitData.subDepartmentId = submitValueData.subDepartmentId;
        submitData.serviceId = submitValueData.serviceId;
        submitData.doctorId = submitValueData.doctorId;
        submitData.associateId = submitValueData.associateId && submitValueData.associateId.trim() !== ""
            ? submitValueData.associateId
            : undefined;
        submitData.visitDate = submitValueData.visitDate.trim() ?? '';
        submitData.nextVisitDate = submitValueData.nextVisitDate.trim() ?? '';
        submitData.feeStatus = submitValueData.feeStatus.trim() ?? '';
        submitData.feeAmount = submitValueData.feeAmount;

        //add for image
        if (requestType === "Edit") {
            // // debugger
            // submitData.id = submitValueData?.id;
            // const id = submitValueData?.id;
            // // assuming ID comes from backend
            // medicalFeeDetailController
            //     .Update(id, submitData, token)
            //     .then((response) => {
            //         if (response.status === 200) {

            //             getAllFeeDetail()
            //             showAlert("success", response?.data?.message);
            //             handleFeeDetailPopup(false);
            //             setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            //             // getAllCenters();
            //         } else {
            //             if (response?.response?.data?.status === 400)
            //                 showAlert("error", response?.response?.data?.message);
            //             else if (response?.response?.status === 409)
            //                 showAlert("error", response?.response?.data?.message);
            //             else if (response?.response?.status === 500)
            //                 showAlert("error", response?.response?.data?.message);

            //             setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            //         }
            //     })
            //     .catch((error) => {
            //         showAlert("error", "Oops something went wrong.");
            //         setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            //     });
        } else {
            medicalFeeDetailController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllFeeDetail()
                        handleFeeDetailPopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 400) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }

    }
    const submitFeeReceiptValues = (submitValueData) => {
        // //debugger
        let submitData = {}
        submitData.tenantId = tenantId;
        // Map form fields
        submitData.feeDetailsId = submitValueData?.feeDetailsId?.trim() ?? '';
        submitData.patientId = submitValueData?.patientId?.trim() ?? '';
        submitData.paymentAmount = submitValueData?.paymentAmount ?? '';
        submitData.modeOfPayment = submitValueData?.modeOfPayment?.trim() ?? '';
        submitData.dateOfReceipt = submitValueData?.dateOfReceipt?.trim() ?? '';
        submitData.transactionReferenceNumber = submitValueData?.transactionReferenceNumber?.trim() ?? '';
        submitData.paymentReferenceNumber = submitValueData?.paymentReferenceNumber?.trim() ?? '';
        submitData.receiptNo = submitValueData?.receiptNo?.trim() ?? '';
        submitData.receiptDate = submitValueData?.receiptDate?.trim() ?? '';

        //add for image
        //debugger
        if (requestType === "Edit") {
            submitData.id = submitValueData?.id;
            const id = submitValueData?.id;
            // assuming ID comes from backend
            medicalFeeReceiptController
                .Update(id, submitData, token)
                .then((response) => {
                    if (response.status === 200) {

                        getAllFeeReceipt()
                        showAlert("success", response?.data?.message);
                        handleFeeReceiptDetailPopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        getAllFeeReceipt();
                    } else {
                        if (response?.response?.data?.status === 400)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            medicalFeeReceiptController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllPatient()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 400) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    const handleFeeReceiptDetailPopup = (value) => setFeeReceiptDetailPopup(() => value);
    const handleFeeReceiptDetailData = () => setFeeReceiptDetailPopup(() => true);
    const handleFeeDetailPopup = (value) => setFeeDetailPopup(() => value);
    const handleFeeDetailData = () => setFeeDetailPopup(() => true);
    const handlePopup3 = (value) => setPopUp3(value);
    const handleData3 = () => setPopUp3(true);

    const handleSearch = (familyNumber) => {
        if (familyNumber) {
            const mobData = { mob: familyNumber };
            handleFamilyName(mobData);
        } else {
            showAlert("error", "Please input the family mobile number field");
        }
    };
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <Grid item xs={12} md={12}
                                                className={patientPage ? "adduser" : ""}
                                            >
                                                <Controls.ActionButton onClick={() => PatientPage()}>
                                                    <span>Patients</span>
                                                </Controls.ActionButton>
                                            </Grid>
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <Grid item xs={12} md={12}
                                                className={feeDetailPage ? "adduser" : ""}
                                            >
                                                <Controls.ActionButton onClick={() => FeeDetailPage()}>
                                                    <span>Fee Details</span>
                                                </Controls.ActionButton>
                                            </Grid>
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <Grid item xs={12} md={12}
                                                className={feeReceiptDetailPage ? "adduser" : ""}
                                            >
                                                <Controls.ActionButton onClick={() => FeeReceiptDetailPage()} >
                                                    <span>Fee Receipt</span>
                                                </Controls.ActionButton>
                                            </Grid>
                                        </li>


                                        {/* <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Patient</h6>
                                        </li> */}
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    {patientPage && (
                        <>
                            <Grid item xs={12} md={12} className="adduser">
                                <Controls.ActionButton onClick={() => AddPatient()}>
                                    <span>Add New Patient</span>
                                </Controls.ActionButton>
                            </Grid>
                            <Grid item xs={12} className="formBg">
                                <Container maxWidth="md" className="formClwidth">
                                    <div>
                                        <Controls.Grid
                                            columns={columns}
                                            data={patientData}
                                            fileName={"Users"}
                                        />
                                        {popup && (
                                            <Controls.Popup
                                                title="Patient Details"
                                                openPopup={popup}
                                                setOpenPopup={handlePopup}
                                            >
                                                <Formik
                                                    enableReinitialize
                                                    initialValues={{
                                                        ...(updatedValues || INITIAL_FORM_STATE),
                                                    }}
                                                    validationSchema={FORM_VALIDATION}
                                                    onSubmit={(values) => submitValues(values)}
                                                >
                                                    {({ values, handleChange, setFieldValue }) => (
                                                        <Form>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientFirstName"
                                                                        label="Patient First Name"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 100 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientMiddleName"
                                                                        label="Patient Middle Name"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 100 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientLastName"
                                                                        label="Patient Last Name"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 100 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientEmailId"
                                                                        label="Patient Email"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientMobileNumber"
                                                                        label="Patient Mobile"
                                                                        type="string"
                                                                        inputProps={{
                                                                            maxLength: 10,
                                                                            inputMode: "numeric",
                                                                            pattern: "[0-9]*",
                                                                        }}
                                                                        onChange={(e) => {
                                                                            const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                                                                            e.target.value = onlyNumbers;
                                                                            handleChange(e); // keep Formik in sync

                                                                            if (onlyNumbers) {
                                                                                setShowMobileOptions(true);
                                                                                if (!values.patientMobileType) {
                                                                                    setFieldValue("patientMobileType", "selfMobile");
                                                                                } else {
                                                                                    setFieldValue("patientMobileType", "familyMobile");
                                                                                }
                                                                            } else {
                                                                                setShowMobileOptions(false);
                                                                                setFieldValue("patientMobileType", "");
                                                                            }
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                {showMobileOptions && (
                                                                    <Grid item xs={12} md={6}>
                                                                        <RadioGroup
                                                                            row
                                                                            name="patientMobileType"
                                                                            value={values.patientMobileType || ""}
                                                                            onChange={(e) => setFieldValue("patientMobileType", e.target.value)}
                                                                        >
                                                                            <FormControlLabel value="selfMobile" control={<Radio />} label="Self Mobile" />
                                                                            <FormControlLabel value="familyMobile" control={<Radio />} label="Family Mobile" />
                                                                        </RadioGroup>
                                                                    </Grid>
                                                                )}

                                                                {isDropdown ? (
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.AutoComplete
                                                                            name="patientFamilyId"
                                                                            value={
                                                                                familyNameDD?.find(
                                                                                    (opt) => opt.patientFamilyId === values.patientFamilyId) || null
                                                                            }
                                                                            label={
                                                                                <span>
                                                                                    Select family name <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            options={familyNameDD || []}
                                                                            getOptionLabel={(option) => option?.familyName || ""}
                                                                            isOptionEqualToValue={(option, value) => option?.patientFamilyId === value?.patientFamilyId}
                                                                            onChange={(event, value) => {
                                                                                if (value) {
                                                                                    setFieldValue("familyName", value ? value.familyName : ""); // ✅ only save string
                                                                                    setFieldValue("patientFamilyId", value ? value.patientFamilyId : ""); // ✅ only save string
                                                                                }
                                                                                handleChange(event);
                                                                            }}
                                                                        />
                                                                    </Grid >
                                                                ) : (
                                                                    <Grid item xs={12} md={5}>
                                                                        <Controls.Textfield
                                                                            name="familyMobileNumber"
                                                                            label={
                                                                                <span>
                                                                                    Family mobile number
                                                                                </span>
                                                                            }
                                                                            inputProps={{
                                                                                maxLength: 10,
                                                                                inputMode: "numeric",
                                                                                pattern: "[0-9]*",
                                                                            }}
                                                                            onChange={(e) => {
                                                                                const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                                                                                e.target.value = onlyNumbers;
                                                                                setFieldValue(
                                                                                    "familyMobileNumber",
                                                                                    e?.target?.value
                                                                                );
                                                                                handleChange(e); // keep Formik in sync
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                )}
                                                                {!isDropdown && (
                                                                    <Grid item xs={12} md={1}>
                                                                        <SearchIcon
                                                                            className="btn-save"
                                                                            onClick={() =>
                                                                                handleSearch(values.familyMobileNumber)
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                )}
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientPincode"
                                                                        label="Patient PinCode"
                                                                        type="text"
                                                                        inputProps={{ maxLength: 6, inputMode: "numeric", pattern: "[0-9]*" }}
                                                                        onChange={(e) => {
                                                                            // ✅ allow only digits
                                                                            const value = e.target.value.replace(/\D/g, ""); // remove non-numeric characters
                                                                            e.target.value = value; // update input with only digits
                                                                            handleChange(e); // keep Formik in sync
                                                                            if (/^\d{6}$/.test(value)) {
                                                                                getPinCodeData(value, setFieldValue);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientCity"
                                                                        label="Patient City"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientState"
                                                                        label="Patient State"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientAddress1"
                                                                        label="Patient Address1"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="patientAddress2"
                                                                        label="Patient Address2"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={4} md={2} className="marginAuto">
                                                                <Controls.Button>Submit</Controls.Button>
                                                            </Grid>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </Controls.Popup>
                                        )}
                                        {/* if you want to add family mob no then add popup3 */}
                                    </div>
                                </Container>
                            </Grid>
                        </>
                    )}
                    {feeDetailPage && (
                        <>
                            <Grid item xs={12} md={12} className="adduser">
                                <Controls.ActionButton onClick={() => AddFeeDetail()}>
                                    <span>Add Fee Details</span>
                                </Controls.ActionButton>
                            </Grid>
                            <Grid item xs={12} className="formBg">
                                <Container maxWidth="md" className="formClwidth">
                                    <div>
                                        {/* <Controls.Grid
                                            // columns={feeDetailColumns}
                                            // data={feeDetailData}
                                            // fileName={"Users"}
                                        /> */}
                                        <Controls.Grid
                                            columns={getFeeColumns(
                                                () => { }, // initially empty
                                                setUpdatedFeeDetailValues,
                                                handleFeeDetailPopup
                                            )}
                                            data={feeDetailData}
                                            fileName="FeeDetails"
                                        />
                                        {feeDetailPopup && (
                                            <Controls.Popup
                                                title="Fee Details"
                                                openPopup={feeDetailPopup}
                                                setOpenPopup={handleFeeDetailPopup}
                                            >
                                                <Formik
                                                    enableReinitialize
                                                    initialValues={{
                                                        ...(updatedFeeDetailValues || FeeDetails_INITIAL_FORM_STATE),
                                                    }}
                                                    // validationSchema={FeeDetails_FORM_VALIDATION}
                                                    onSubmit={(values) => submitFeeDetailValues(values)}
                                                >
                                                    {({ values,
                                                        handleChange,
                                                        setFieldTouched,
                                                        setFieldValue
                                                    }) => {
                                                        // Helper: remove subDepartments + related services & doctors when department unchecked
                                                        const removeSubDepartmentsByDeptId = (deptId, values, setFieldValue) => {
                                                            const subsToRemove = subDepartmentOptions
                                                                .filter((sd) => sd.departmentId === deptId)
                                                                .map((sd) => sd.subDepartmentId);

                                                            // 1. Remove subDepartments from options
                                                            setSubDepartmentOptions((prev) =>
                                                                prev.filter((subDept) => subDept.departmentId !== deptId)
                                                            );

                                                            // 2. Remove selected subDeptIds that belonged to this dept
                                                            setFieldValue(
                                                                "subDepartmentId",
                                                                (values.subDepartmentId || []).filter((id) => !subsToRemove.includes(id))
                                                            );

                                                            // 3. Remove services belonging to those subDepartments (from options)
                                                            setServiceOptions((prev) =>
                                                                prev.filter((service) => !subsToRemove.includes(service.subDepartmentId))
                                                            );

                                                            // 4. Remove selected services belonging to those subDepartments
                                                            setFieldValue(
                                                                "serviceId",
                                                                (values.serviceId || []).filter((id) => {
                                                                    const service = serviceOptions.find((s) => s.serviceId === id);
                                                                    return !service || !subsToRemove.includes(service.subDepartmentId);
                                                                })
                                                            );

                                                            // 5. Remove doctors belonging to those subDepartments (from options)
                                                            setDoctorOptions((prev) =>
                                                                prev.filter((doctor) => !subsToRemove.includes(doctor.subDepartmentId))
                                                            );

                                                            // 6. Remove selected doctors belonging to those subDepartments
                                                            setFieldValue(
                                                                "doctorId",
                                                                (values.doctorId || []).filter((id) => {
                                                                    const doc = doctorOptions.find((d) => d.doctorId === id);
                                                                    return !doc || !subsToRemove.includes(doc.subDepartmentId);
                                                                })
                                                            );
                                                        };

                                                        // Handle department checkbox change
                                                        const handleDepartmentChange = async (dept, checked) => {
                                                            debugger
                                                            let updated = [...(values.departmentId || [])];

                                                            if (checked) {
                                                                updated.push(dept.departmentId);
                                                                setFieldValue("departmentId", updated);

                                                                // Fetch subDepartments
                                                                const subs = (await getSubDepartment(dept.departmentId)) || [];
                                                                setSubDepartmentOptions((prev = []) => {
                                                                    const all = [...prev, ...subs];
                                                                    return all.filter(
                                                                        (item, index, self) =>
                                                                            index === self.findIndex((s) => s.subDepartmentId === item.subDepartmentId)
                                                                    );
                                                                });

                                                                // ✅ Fetch doctors by department
                                                                const doctors = (await getDoctorsByDepartmentId(dept.departmentId)) || [];
                                                                setDoctorOptions((prev = []) => {
                                                                    const all = [...prev, ...doctors];
                                                                    return all.filter(
                                                                        (item, index, self) =>
                                                                            index === self.findIndex((d) => d.doctorId === item.doctorId)
                                                                    );
                                                                });

                                                            } else {
                                                                updated = updated.filter((id) => id !== dept.departmentId);
                                                                setFieldValue("departmentId", updated);
                                                                removeSubDepartmentsByDeptId(dept.departmentId, values, setFieldValue);

                                                                // ❌ also remove doctors of this department
                                                                setDoctorOptions((prev) =>
                                                                    prev.filter((doctor) => doctor.departmentId !== dept.departmentId)
                                                                );
                                                                setFieldValue(
                                                                    "doctorId",
                                                                    (values.doctorId || []).filter((id) => {
                                                                        const doc = doctorOptions.find((d) => d.doctorId === id);
                                                                        return !doc || doc.departmentId !== dept.departmentId;
                                                                    })
                                                                );
                                                            }
                                                        };

                                                        // Handle subDepartment checkbox change
                                                        const handleSubDepartmentChange = async (subDept, checked) => {
                                                            let updatedSubDepartments = [...(values.subDepartmentId || [])];

                                                            if (checked) {
                                                                updatedSubDepartments.push(subDept.subDepartmentId);
                                                                setFieldValue("subDepartmentId", updatedSubDepartments);

                                                                // Fetch services
                                                                const services = (await getServicesBySubDepartmentId(subDept.subDepartmentId)) || [];
                                                                setServiceOptions((prev = []) => {
                                                                    const all = [...prev, ...services];
                                                                    return all.filter(
                                                                        (item, index, self) =>
                                                                            index === self.findIndex((s) => s.serviceId === item.serviceId)
                                                                    );
                                                                });

                                                            } else {
                                                                updatedSubDepartments = updatedSubDepartments.filter(
                                                                    (id) => id !== subDept.subDepartmentId
                                                                );
                                                                setFieldValue("subDepartmentId", updatedSubDepartments);

                                                                // 1. Remove services of this subDepartment (options)
                                                                setServiceOptions((prev) =>
                                                                    prev.filter((service) => service.subDepartmentId !== subDept.subDepartmentId)
                                                                );

                                                                // 2. Remove selected services of this subDepartment
                                                                setFieldValue(
                                                                    "serviceId",
                                                                    (values.serviceId || []).filter((id) => {
                                                                        const service = serviceOptions.find((s) => s.serviceId === id);
                                                                        return !service || service.subDepartmentId !== subDept.subDepartmentId;
                                                                    })
                                                                );

                                                                // 3. Remove doctors of this subDepartment (options)
                                                                setDoctorOptions((prev) =>
                                                                    prev.filter((doctor) => doctor.subDepartmentId !== subDept.subDepartmentId)
                                                                );

                                                                // 4. Remove selected doctors of this subDepartment
                                                                setFieldValue(
                                                                    "doctorId",
                                                                    (values.doctorId || []).filter((id) => {
                                                                        const doc = doctorOptions.find((d) => d.doctorId === id);
                                                                        return !doc || doc.subDepartmentId !== subDept.subDepartmentId;
                                                                    })
                                                                );
                                                            }
                                                        };

                                                        // Search filters (unchanged)
                                                        // const filteredDepartments = (departmentOptions || []).filter((dept) =>
                                                        //     dept.departmentName.toLowerCase().includes(departmentSearch.toLowerCase())
                                                        // );
                                                        const filteredDepartments = (departmentOptions || []).filter((dept) =>
                                                            (Array.isArray(dept.departmentName) ? dept.departmentName.join(" ") : dept.departmentName || "")
                                                                .toLowerCase()
                                                                .includes(departmentSearch.toLowerCase())
                                                        );

                                                        // SubDepartments
                                                        const filteredSubDepartments = (subDepartmentOptions || []).filter((subDept) =>
                                                            (Array.isArray(subDept.subDepartmentName) ? subDept.subDepartmentName.join(" ") : subDept.subDepartmentName || "")
                                                                .toString()
                                                                .toLowerCase()
                                                                .includes(subDeptSearch.toLowerCase())
                                                        );

                                                        // Services
                                                        const filteredServices = (serviceOptions || []).filter((service) =>
                                                            (Array.isArray(service.serviceName) ? service.serviceName.join(" ") : service.serviceName || "")
                                                                .toString()
                                                                .toLowerCase()
                                                                .includes(serviceSearch.toLowerCase())
                                                        );

                                                        // Doctors
                                                        const filteredDoctors = (doctorOptions || []).filter((doctor) =>
                                                            (Array.isArray(doctor.doctorName) ? doctor.doctorName.join(" ") : doctor.doctorName || "")
                                                                .toString()
                                                                .toLowerCase()
                                                                .includes(doctorSearch.toLowerCase())
                                                        );

                                                        return (
                                                            <Form>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.AutoComplete
                                                                            name="patientId"
                                                                            value={
                                                                                patientOptions?.find(
                                                                                    (opt) => opt.patientId === values.patientId) || null
                                                                            }
                                                                            label={
                                                                                <span>
                                                                                    Select Patient Name <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            options={patientOptions || []}
                                                                            getOptionLabel={(option) => option?.patientName || ""}
                                                                            isOptionEqualToValue={(option, value) => option?.patientId === value?.patientId}
                                                                            onChange={(event, value) => {
                                                                                setFieldValue("patientName", value ? value.patientName : "");
                                                                                setFieldValue("patientId", value ? value.patientId : "");
                                                                                handleChange(event)
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    {/* Department Selection */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="Search Departments"
                                                                            value={departmentSearch}
                                                                            onChange={(e) => setDepartmentSearch(e.target.value)}
                                                                            margin="dense"
                                                                        />
                                                                        <FormGroup row>
                                                                            {filteredDepartments.map((dept) => {

                                                                                console.log('values :', values);
                                                                                // console.log('values.departmentId?.includes(String(dept.departmentId)) :', values?.departments[0].departmentId?.includes("68d66b2a5d8916cd7fb261c0"));
                                                                                // console.log("Checkbox render:", {
                                                                                //         deptId: String(dept.departmentId),
                                                                                //         isChecked: values.departmentId?.includes(String(dept.departmentId)),
                                                                                //         formValue: values.departmentId,
                                                                                //     });

                                                                                return (
                                                                                    <FormControlLabel
                                                                                        key={dept.departmentId}
                                                                                        control={
                                                                                            <Checkbox
                                                                                                name="departmentId"
                                                                                                // checked={values.departmentId?.includes(String(dept.departmentId))}
                                                                                                // checked={values.departments?.some(d => d.departmentId === dept.departmentId)}
                                                                                                checked={values?.departments?.some(d => d.departmentId === dept.departmentId)}
                                                                                                onChange={(e) => handleDepartmentChange(dept, e.target.checked)}
                                                                                            />
                                                                                        }
                                                                                        label={dept.departmentName}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </FormGroup>
                                                                    </Grid>

                                                                    {/* Sub-Department Selection */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="Search Sub-departments"
                                                                            value={subDeptSearch}
                                                                            onChange={(e) => setSubDeptSearch(e.target.value)}
                                                                            margin="dense"
                                                                        />
                                                                        <FormGroup row>
                                                                            {filteredSubDepartments.map((subDept) => (
                                                                                <FormControlLabel
                                                                                    key={subDept.subDepartmentId}
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={values.subDepartmentId?.includes(subDept.subDepartmentId)}
                                                                                            onChange={(e) =>
                                                                                                handleSubDepartmentChange(subDept, e.target.checked)
                                                                                            }
                                                                                        />
                                                                                    }
                                                                                    label={subDept.subDepartmentName}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </Grid>

                                                                    {/* Services Selection */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="Search Services"
                                                                            value={serviceSearch}
                                                                            onChange={(e) => setServiceSearch(e.target.value)}
                                                                            margin="dense"
                                                                        />
                                                                        <FormGroup row>
                                                                            {filteredServices.map((service) => (
                                                                                <FormControlLabel
                                                                                    key={service.serviceId}
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={values.serviceId?.includes(service.serviceId)}
                                                                                            onChange={(e) => {
                                                                                                const checked = e.target.checked;
                                                                                                let updated = [...(values.serviceId || [])];
                                                                                                if (checked) {
                                                                                                    updated.push(service.serviceId);
                                                                                                } else {
                                                                                                    updated = updated.filter((id) => id !== service.serviceId);
                                                                                                }
                                                                                                setFieldValue("serviceId", updated);
                                                                                            }}
                                                                                        />
                                                                                    }
                                                                                    label={service.serviceName}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </Grid>

                                                                    {/* Doctor Selection */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="Search Doctors"
                                                                            value={doctorSearch}
                                                                            onChange={(e) => setDoctorSearch(e.target.value)}
                                                                            margin="dense"
                                                                        />
                                                                        <FormGroup row>
                                                                            {filteredDoctors.map((doctor) => (
                                                                                <FormControlLabel
                                                                                    key={doctor.doctorId}
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={values.doctorId?.includes(doctor.doctorId)}
                                                                                            onChange={(e) => {
                                                                                                const checked = e.target.checked;
                                                                                                let updated = [...(values.doctorId || [])];
                                                                                                if (checked) {
                                                                                                    updated.push(doctor.doctorId);
                                                                                                } else {
                                                                                                    updated = updated.filter((id) => id !== doctor.doctorId);
                                                                                                }
                                                                                                setFieldValue("doctorId", updated);
                                                                                            }}
                                                                                        />
                                                                                    }
                                                                                    label={doctor.doctorName}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </Grid>
                                                                    {/* <Grid item xs={12} md={6}>
                                                                        <Controls.AutoComplete
                                                                            name="doctorId"
                                                                            value={
                                                                                doctorOptions?.find(
                                                                                    (opt) => opt.doctorId === values.doctorId) || null
                                                                            }
                                                                            label={
                                                                                <span>
                                                                                    Select Doctor Name <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            options={doctorOptions || []}
                                                                            getOptionLabel={(option) => option?.doctorName || ""}
                                                                            isOptionEqualToValue={(option, value) => option?.doctorId === value?.doctorId}
                                                                            onChange={(event, value) => {
                                                                                setFieldValue("doctorName", value ? value.doctorName : "");
                                                                                setFieldValue("doctorId", value ? value.doctorId : "");
                                                                                handleChange(event)
                                                                            }}
                                                                        />
                                                                    </Grid> */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.AutoComplete
                                                                            name="associateId"
                                                                            value={
                                                                                associateOptions?.find(
                                                                                    (opt) => opt.associateId === values.associateId) || null
                                                                            }
                                                                            label={
                                                                                <span>
                                                                                    Select Associate Name <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            options={associateOptions || []}
                                                                            getOptionLabel={(option) => option?.associateName || ""}
                                                                            isOptionEqualToValue={(option, value) => option?.associateId === value?.associateId}
                                                                            onChange={(event, value) => {
                                                                                setFieldValue("associateName", value ? value.associateName : "");
                                                                                setFieldValue("associateId", value ? value.associateId : "");
                                                                                handleChange(event)
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.DateTimePicker
                                                                            name="visitDate"
                                                                            label={
                                                                                <span>
                                                                                    Visit Date <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            type="string"
                                                                            disableFuture={true}
                                                                            value={
                                                                                values?.visitDate
                                                                                    ? dayjs(values?.visitDate, "DD/MM/YYYY")
                                                                                    : null
                                                                            }
                                                                            onChange={(e) =>
                                                                                handleVisitDateChange(
                                                                                    setFieldTouched,
                                                                                    setFieldValue,
                                                                                    e
                                                                                )
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.DateTimePicker
                                                                            name="nextVisitDate"
                                                                            label={
                                                                                <span>
                                                                                    Next Visit Date <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            type="string"
                                                                            // disableFuture={true}
                                                                            value={
                                                                                values?.nextVisitDate
                                                                                    ? dayjs(values?.nextVisitDate, "DD/MM/YYYY")
                                                                                    : null
                                                                            }
                                                                            onChange={(e) =>
                                                                                handleNextVisitDateChange(
                                                                                    setFieldTouched,
                                                                                    setFieldValue,
                                                                                    e
                                                                                )
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.AutoComplete
                                                                            name="feeStatus"
                                                                            value={
                                                                                feeStatusOptions.find((opt) => opt.value === values.feeStatus) || null
                                                                            }
                                                                            label={
                                                                                <span>
                                                                                    Fee Status <span className="asterisk">*</span>
                                                                                </span>
                                                                            }
                                                                            options={feeStatusOptions}
                                                                            getOptionLabel={(option) => option.label || ""}
                                                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                                                            onChange={(event, value) => {
                                                                                setFieldValue("feeStatus", value ? value.value : "");
                                                                                handleChange(event);
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6}>
                                                                        <Controls.Textfield
                                                                            name="feeAmount"
                                                                            label="Fee Amount"
                                                                            type="string"
                                                                            inputProps={{ maxLength: 10 }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={4} md={2} className="marginAuto">
                                                                    <Controls.Button>Submit</Controls.Button>
                                                                </Grid>
                                                            </Form>
                                                        )
                                                    }}
                                                </Formik>
                                            </Controls.Popup>
                                        )}
                                        {/* if you want to add family mob no then add popup3 */}
                                    </div>
                                </Container>
                            </Grid>
                        </>
                    )}
                    {feeReceiptDetailPage && (
                        <>
                            <Grid item xs={12} md={12} className="adduser">
                                <Controls.ActionButton onClick={() => AddFeeReceiptDetail()}>
                                    <span>Add FeeReceipt Details</span>
                                </Controls.ActionButton>
                            </Grid>
                            <Grid item xs={12} className="formBg">
                                <Container maxWidth="md" className="formClwidth">
                                    <div>
                                        <Controls.Grid
                                            columns={feeReceiptColumns}
                                            data={feeReceiptData}
                                            fileName={"Users"}
                                        />
                                        {feeReceiptDetailPopup && (
                                            <Controls.Popup
                                                title="Fee Receipt Detail"
                                                openPopup={feeReceiptDetailPopup}
                                                setOpenPopup={handleFeeReceiptDetailPopup}
                                            >
                                                <Formik
                                                    enableReinitialize
                                                    initialValues={{
                                                        ...(
                                                            updatedFeeReceiptDetailValues
                                                            || FeeReceiptDetails_INITIAL_FORM_STATE
                                                        ),
                                                    }}
                                                    validationSchema={FeeReceiptDetails_FORM_VALIDATION}
                                                    onSubmit={(values) => submitFeeReceiptValues(values)}
                                                >
                                                    {({ values, handleChange, setFieldValue, setFieldTouched }) => (
                                                        <Form>
                                                            <Grid container spacing={2}>
                                                                {/* <Grid item xs={12} md={6}>
                                                                    <Controls.AutoComplete
                                                                        name="feeDetailsId"
                                                                        value={
                                                                            feeDetailData?.find(
                                                                                (opt) => opt.id === values.id) || null
                                                                        }
                                                                        label={
                                                                            <span>
                                                                                Select Patient Name <span className="asterisk">*</span>
                                                                            </span>
                                                                        }
                                                                        options={feeDetailData || []}
                                                                        getOptionLabel={(option) => option?.patientName || ""}
                                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                                        onChange={(event, value) => {
                                                                            setFieldValue("patientName", value ? value.id : "");
                                                                            setFieldValue("patientId", value ? value.patientId : "");
                                                                            setFieldValue("feeDetailsId", value ? value.id : "");
                                                                            handleChange(event)
                                                                        }}
                                                                    />
                                                                </Grid> */}
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.AutoComplete
                                                                        name="feeDetailsId"
                                                                        value={
                                                                            feeReceiptOption?.find(
                                                                                (opt) => opt.id === values.feeDetailsId
                                                                            ) || null
                                                                        }
                                                                        label={
                                                                            <span>
                                                                                Select Patient Name <span className="asterisk">*</span>
                                                                            </span>
                                                                        }
                                                                        options={feeReceiptOption || []}
                                                                        getOptionLabel={(option) => option?.patientName || ""}
                                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                                        onChange={(event, value) => {
                                                                            setFieldValue("feeDetailsId", value ? value.id : "");
                                                                            setFieldValue("patientId", value ? value.patientId : "");
                                                                            setFieldValue("patientName", value ? value.patientName : "");
                                                                        }}
                                                                        disabled={requestType === "Edit"}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="paymentAmount"
                                                                        label="payment Amount"
                                                                        type="number"
                                                                        inputProps={{ maxLength: 10 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.AutoComplete
                                                                        name="modeOfPayment"
                                                                        value={
                                                                            paymentModeOptions.find((opt) => opt.value === values.modeOfPayment) || null
                                                                        }
                                                                        label={
                                                                            <span>
                                                                                Select Mode Of Payment <span className="asterisk">*</span>
                                                                            </span>
                                                                        }
                                                                        options={paymentModeOptions}
                                                                        getOptionLabel={(option) => option.label}
                                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                                        onChange={(event, value) => {
                                                                            setFieldValue("modeOfPayment", value ? value.value : "");
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.DateTimePicker
                                                                        name="dateOfReceipt"
                                                                        label={
                                                                            <span>
                                                                                Date Of Receipt <span className="asterisk">*</span>
                                                                            </span>
                                                                        }
                                                                        type="string"
                                                                        // disableFuture={true}
                                                                        value={
                                                                            values?.dateOfReceipt
                                                                                ? dayjs(values?.dateOfReceipt, "DD/MM/YYYY")
                                                                                : null
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleDateOfReceiptChange(
                                                                                setFieldTouched,
                                                                                setFieldValue,
                                                                                e
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="transactionReferenceNumber"
                                                                        label="Transaction Reference Number"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="paymentReferenceNumber"
                                                                        label="Payment Reference Number"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.Textfield
                                                                        name="receiptNo"
                                                                        label="Receipt No"
                                                                        type="string"
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Controls.DateTimePicker
                                                                        name="receiptDate"
                                                                        label={
                                                                            <span>
                                                                                Receipt Date<span className="asterisk">*</span>
                                                                            </span>
                                                                        }
                                                                        type="string"
                                                                        disableFuture={true}
                                                                        value={
                                                                            values?.receiptDate
                                                                                ? dayjs(values?.receiptDate, "DD/MM/YYYY")
                                                                                : null
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleReceiptDateChange(
                                                                                setFieldTouched,
                                                                                setFieldValue,
                                                                                e
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={4} md={2} className="marginAuto">
                                                                <Controls.Button>Submit</Controls.Button>
                                                            </Grid>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </Controls.Popup>
                                        )}
                                        {/* if you want to add family mob no then add popup3 */}
                                    </div>
                                </Container>
                            </Grid>
                        </>
                    )}


                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default Patient;
